// AUTO-CRM-32: copied from the Auto Appy app (src/features/Workspace/WorkspaceUi.jsx); keep the two in step.
import React from 'react';
import { Workflow } from 'lucide-react';
import { characterFor } from './characters';

export function AgentAvatar({ characterKey, size = 36, name = '', full = false }) {
  const character = characterFor(characterKey);
  const radius = Math.round(size * 0.3);
  if (!character) {
    return (
      <span className="ws-avatar ws-avatar--blank" style={{ width: size, height: size, borderRadius: radius }} aria-hidden="true">
        <Workflow size={Math.max(14, Math.round(size * 0.44))} strokeWidth={1.9} />
      </span>
    );
  }
  return (
    <span className="ws-avatar" style={{ width: size, height: size, borderRadius: radius, background: character.tint }}>
      <img src={full && character.full ? character.full : character.image} alt={name ? `${name}'s character` : ''} loading="lazy" />
    </span>
  );
}

export function Monogram({ name = '', size = 32 }) {
  const initials = name.split(/\s+/).filter(Boolean).map((part) => part[0]).join('').slice(0, 2).toUpperCase() || 'AA';
  return <span className="ws-monogram" style={{ width: size, height: size, fontSize: Math.round(size * 0.36) }} aria-hidden="true">{initials}</span>;
}

const STATUS_LABELS = { live: 'Live', paused: 'Paused', draft: 'Draft', failed: 'Failed', warning: 'Warning', info: 'Scheduled' };

export function Status({ tone = 'draft', children }) {
  return <span className={`ws-status ws-status--${tone}`}>{children || STATUS_LABELS[tone] || tone}</span>;
}

export function Skeleton({ width = '100%', height = 14, radius = 8, style }) {
  return <span className="ws-skeleton" style={{ display: 'block', width, height, borderRadius: radius, ...style }} aria-hidden="true" />;
}

export const firstName = (name = '') => String(name).trim().split(/\s+/)[0] || '';

export function greetingFor(date = new Date()) {
  const hour = date.getHours();
  if (hour < 12) return 'Good morning';
  if (hour < 17) return 'Good afternoon';
  return 'Good evening';
}

export const formatNumber = (value) => (Number.isFinite(Number(value)) ? Number(value).toLocaleString('en-IN') : '—');

export function formatTime(value) {
  const date = value ? new Date(value) : null;
  if (!date || Number.isNaN(date.getTime())) return '—';
  return date.toLocaleTimeString('en-IN', { hour: 'numeric', minute: '2-digit', hour12: true }).replace(/\s?(am|pm)$/i, (m) => ` ${m.trim().toUpperCase()}`);
}

export function formatDay(value, now = new Date()) {
  const date = value ? new Date(value) : null;
  if (!date || Number.isNaN(date.getTime())) return '';
  const startOf = (d) => new Date(d.getFullYear(), d.getMonth(), d.getDate()).getTime();
  const diff = Math.round((startOf(date) - startOf(now)) / 86400000);
  if (diff === 0) return 'Today';
  if (diff === 1) return 'Tomorrow';
  if (diff === -1) return 'Yesterday';
  return date.toLocaleDateString([], { weekday: 'short', day: 'numeric', month: 'short' });
}

// A character on its tinted stage. Full-body art is fitted inside the stage so
// heads and feet are never clipped; head-only art sits centred.
export function CharacterStage({ character, height = 188, children, empty = null }) {
  return (
    <div className="ws-stage" style={{ height, background: character?.tint || undefined }}>
      {character && <span className="ws-stage-glow" aria-hidden="true" />}
      {character && character.full && <img className="ws-stage-full" src={character.full} alt="" />}
      {character && !character.full && <img className="ws-stage-face" src={character.image} alt="" />}
      {!character && empty}
      {children}
    </div>
  );
}
